import { Outlet } from "react-router-dom";
import { Shield } from "@phosphor-icons/react";
import { config } from "@/config";
import { Badge } from "@/components/ui/Badge";

/**
 * Layout wrapper for the admin app's own auth pages (today: just login).
 *
 * Deliberately plain — the frontend app's AuthLayout sells the product
 * (hero copy, social proof, a register/login toggle); none of that applies
 * to an internal console that provisions accounts out of band.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="mb-8 flex items-center gap-2">
        <Shield className="h-6 w-6 text-primary" />
        <span className="text-lg font-semibold tracking-tight">
          Spark Admin
        </span>
        {config.environmentBadge && (
          <Badge variant="warning" className="px-1.5 py-0 text-[10px]">
            {config.environmentBadge}
          </Badge>
        )}
      </div>
      <div className="w-full max-w-md rounded-2xl border border-border/50 bg-card/80 p-6 shadow-xl sm:p-8">
        <Outlet />
      </div>
    </div>
  );
}
